<template>
  <div ref="chartRef" style="width: 100%;height: 100%"></div>
</template>

<script setup>
import * as echarts from "echarts";
import { nextTick, onMounted, ref, watch } from "vue";

const props = defineProps(["data"]);

const chartRef = ref(null);
let chartInstance = null;

const init = () => {
  chartInstance = echarts.init(chartRef.value);
};

onMounted(() => {
  nextTick(() => {
    init();
  })
});

watch(
  () => props.data,
  (val) => {
    setChart(val);
  },
  { deep: true }
);
const typeName=(text)=>{
     let isColor=''
     if(text=='正常'){
        isColor='#409EFF'
     }
    if(text=='轻微'){
        isColor='#67C23A'
     }
     if(text=='中等'){
        isColor='#FFEB3B'
     }
    if(text=='偏重'){
        isColor='#FF9800'
     }
    if(text=='严重'){
        isColor='#F56C6C'
    }
    return isColor
}
const setChart = (val) => {
  let list=[]
  val.places.forEach((item)=>{
      list.push({
         value:item.count,
         name:item.placeText,
         textStyle:{ color: typeName(item.placeText) },
      })
  })
  const option = {
    tooltip: {
      trigger: "item",
    },
    // legend: {
    //   bottom: '5%',
    //   left: 'center',
    //   icon: "circle", // 设置图例的图标为圆形
    //   itemGap: 40, // 设置间距
    //   itemWidth: 10, // 设置图例标记的图形宽度
    //   data: list,
    // },
    graphic: {
      type: "text",
      left: "center",
      top: "middle",
      style: {
        text: `${val.count}人\n${val.name}`,
        textAlign: "center",
        fill: "#6fcaf7",
        fontSize: 16,
        lineHeight: 25,
      },
    },
    series: [
      {
        name: "",
        type: "pie",
        radius:['50%', '80%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderColor: "#fff",
          borderWidth: 0,
        },
        label: {
          show: true, // 显示标签
          position: "inside", // 标签显示在扇形区域内
          formatter: "{c}人/{d}%", // 显示数据值
          color: "#fff", // 标签文字颜色
          fontSize: 14,
        },
        emphasis: {
          label: {
            show: false,
            fontSize: 16,
            fontWeight: "bold",
            color: "#fff",
          },
        },
        labelLine: {
          show: false, // 隐藏标签连线
        },
        data: list,
        color: ["#409EFF", "#67C23A", "#FFEB3B", "#FF9800", "#F56C6C"],
      },
    ],
  };
  chartInstance && chartInstance.setOption(option);
            // 窗口尺寸变化时自动调整图表大小
        window.addEventListener('resize', function() {
            chartInstance.resize();
        });
}

</script>

<style lang="scss" scoped>

</style>